import { NgxsModule } from '@ngxs/store';
import { LocalState } from './local/local.state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export let LocalstateFrontendSharedModule = /*#__PURE__*/(() => {
  class LocalstateFrontendSharedModule {
    static {
      this.ɵfac = function LocalstateFrontendSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LocalstateFrontendSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: LocalstateFrontendSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [NgxsModule.forFeature([LocalState])]
      });
    }
  }
  return LocalstateFrontendSharedModule;
})();